export default __webpack_public_path__ + "static/Inter_variable-b4c30855aff392d7e8dc5de4c692684d.ttf";